import { useContext, useEffect } from 'react';
import { isDate } from 'date-fns';
import { AppContext } from '@/contexts/AppContext';
import { InstanceContext } from '@/contexts/InstanceContext';
import InstanceAndActivityProvider from '@/pages/activity/InstanceAndActivityProvider';
import ActivityInProgress from './ActivityInProgress';
import Celebration from './Celebration';

/**
 * ChildActivityPage — barnvyns gren för /activity/:instanceId.
 *
 * Återanvänder InstanceAndActivityProvider (samma som ViewActivityPage) så att
 * timer/start/complete/subtasks/feeling går mot riktig data. Visar
 * ActivityInProgress tills aktiviteten är klar; så snart dateIsCompleted sätts
 * (av Klar-knappen) växlar vyn till Celebration — samma route, ingen navigering.
 */

const ChildActivitySwitch = () => {
  const { instance } = useContext(InstanceContext);
  const completed = isDate(instance?.dateIsCompleted);
  return completed ? <Celebration /> : <ActivityInProgress />;
};

const ChildActivityPage = () => {
  const { setShowNavbar } = useContext(AppContext);

  // Dölj navbaren i aktivitetsfokus (samma beteende som vuxnas ViewActivityPage).
  useEffect(() => {
    setShowNavbar(false);
    return () => setShowNavbar(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InstanceAndActivityProvider>
      <ChildActivitySwitch />
    </InstanceAndActivityProvider>
  );
};

export default ChildActivityPage;
